import React from 'react'

const BlankLayout = ({ children }) => {
    return <main>{children}</main>
}

export default BlankLayout
